import DistributionByDateAreaChart from './DistributionByDateAreaChart';
export default DistributionByDateAreaChart;



// WEBPACK FOOTER //
// ./src/components/DistributionByDateAreaChart/index.js